window.addEventListener('DOMContentLoaded', () => {
    new Swiper('.basket-accessories-swiper-container', {
        slidesPerView: 1,
        spaceBetween: 20,
        breakpoints: {
            425: {
                slidesPerView: 1.2,
            },
            596: {
                slidesPerView: 2,
            },
            768: {
                slidesPerView: 2.2,
            },
            992: {
                slidesPerView: 2.2,
            },
            1200: {
                slidesPerView: 2.8,
            },
            1440: {
                slidesPerView: 3,
            },
            1600: {
                slidesPerView: 3,
            },
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });
});
